import {
  GET_FAQ_CATEGORIES_REQUEST,
  CREATE_FAQ_CATEGORY_REQUEST,
  UPDATE_FAQ_CATEGORY_REQUEST,
  DELETE_FAQ_CATEGORY_REQUEST,
  CREATE_FAQ_ITEM_REQUEST,
  UPDATE_FAQ_ITEM_REQUEST,
  DELETE_FAQ_ITEM_REQUEST,
} from '../types/faq'

export const getFaqCategories = (payload = {}) => ({
  type: GET_FAQ_CATEGORIES_REQUEST,
  payload,
})

export const createFaqCategory = (payload) => ({
  type: CREATE_FAQ_CATEGORY_REQUEST,
  payload,
})

export const updateFaqCategory = (payload) => ({
  type: UPDATE_FAQ_CATEGORY_REQUEST,
  payload,
})

export const deleteFaqCategory = (payload) => ({
  type: DELETE_FAQ_CATEGORY_REQUEST,
  payload,
})

export const createFaqItem = (payload) => ({
  type: CREATE_FAQ_ITEM_REQUEST,
  payload,
})

export const updateFaqItem = (payload) => ({
  type: UPDATE_FAQ_ITEM_REQUEST,
  payload,
})

export const deleteFaqItem = (payload) => ({
  type: DELETE_FAQ_ITEM_REQUEST,
  payload,
})
